export default {
  'Edit': '修改',
  'Save': '保存',
  'Cancel': '取消',
  'Ok': '確定',
  'and': '和',
  'Yes': '確定',
  'No': '取消',
  'Or': '或',
  'Confirm': '確認提示',
  'Saved success': '修改成功',
  'Warning': '警告',
  'Cancel success': '取消成功',
  'Account binding failure': '賬號綁定失敗',
  'UPDF Code verify': 'UPDF 驗證碼登入',
  'UPDF Login': 'UPDF 登入',
  'UPDF Password login': 'UPDF 密碼登入',
  'UPDF Forgot password': 'UPDF 忘記密碼',
  'UPDF Reset password': 'UPDF 重置密碼',
  'UPDF Set account info': 'UPDF 完善信息',
  'UPDF Callback {loginType}': 'UPDF 登入成功 {loginType }',
  'UPDF Wechat login': 'UPDF 微信登入',
  'Welcome to': '歡迎使用',
  'Wechat': '微信',
  'Click reload': '點擊刷新',
  'Log in by scanning QR code on Wechat<br>and following our official account': '請 使用微信掃描二維碼 <br >並關注公眾號登入',
  'Email': '郵箱',
  'Phone': '手機號',
  'Unregistered account will be registered after entering the verification code': '未註冊手機號或郵箱輸入驗證碼后自動註冊',
  'Unregistered email will be registered after entering the verification code': '未註冊郵箱輸入驗證碼后自動註冊',
  'Or continue with:': '其他登入方式',
  'By clicking continue, you accept our': '點擊下一步即表示您已閱讀並接受',
  'License Agreement': '服務協議',
  'Privacy Policy': '隱私政策',
  'Enter your phone number or email...': '請輸入你的手機號或郵箱',
  'Enter your email address...': '請輸入你的郵箱',
  'Please enter a valid phone number or email': '請輸入有效的手機號或郵箱',
  'Please enter a valid email address': '請輸入有效的郵箱',
  'Please enter your password': '請輸入密碼',
  'Enter new password': '請輸入新密碼',
  'The new password must be at least {min} characters.': '新密碼最少{min}位',
  'The new password must be within {max} characters.': '新密碼最多{max}位',
  'Nickname must be within {max} characters.': '昵稱最多{max}位',
  'Enter your password again': '請再次輸入新密碼',
  'Please enter your password again': '請再次輸入新密碼',
  'Those passwords didn\'t match. Try again.': '兩次密碼輸入不一致',
  'Reset success,please log in use new password': '密碼設置成功，請使用新密碼登入',
  'Continue': '下一步',
  'Check mobile': '驗證手機號',
  'Check email': '驗證郵箱',
  'Please enter the code sent to<br><span>{account}</span>': '請輸入發送至 <span>{account}</span> 的 4 位驗證碼，有效期 10 分鐘',
  'If you do not receive the email, please check your spam or junk folder.': '如未收到郵件，請檢查垃圾郵件文件夾',
  'Resend': '重新獲取驗證碼',
  'seconds remaining to resend code': '秒后可重新獲取驗證碼',
  'Verify Later': '稍後驗證',
  'Log in with password': '使用 帳戶 密碼登入',
  'Log in with password-2': '帳戶 密碼登入',
  'Log in with code': '使用驗證碼登入',
  'OR': '其它登入方式',
  'Back': '返回',
  'Forgot password?': '忘記密碼？',
  'Log in': '登入',
  'Set password': '設置密碼',
  'Reset your password': '重新設置密碼',
  'Add a photo': '設置頭像',
  'Your name': '姓名',
  'What should we call you?': '昵稱',
  'First name': '名',
  'Last name': '姓',
  'Please enter first name': '請輸入名',
  'Please enter last name': '請輸入姓',
  'Please enter your nickname': '請輸入昵稱',
  'Set a password': '密碼',
  'Please enter new password': '請輸入密碼',
  'Set success': '設置成功',
  'Log in success': '登入成功',
  'Click "<span>Open UPDF</span>" in the above dialog box above to log into your account.': '請點擊上方彈窗內“<span>打開UPDF</span>”按鈕完成登入',
  'Can\'t see the dialog box? Click here.': '若未看到彈窗，點擊這裏',
  'Account center': '用戶中心',
  'Account Center': '用戶中心',
  'Account': '帳戶 管理',
  'Personal info': '個人信息',
  'Photo': '頭像',
  'Preferred name': '昵稱',
  'Email-2': '郵箱',
  'UID': 'UID',
  'Mobile phone': '手機號',
  'Country': '國家或地區',
  'Linked Accounts Manage': '綁定賬號管理',
  'Select country': '請選擇國家或地區',
  'Your Plans of UPDF': '你的UPDF會員',
  'Upgrade to UPDF Pro to get full access to all features without limits.': '更多權限請升級為 UPDF Pro 會員。',
  'Subscriptions': '會員權限',
  'You can manage you plan in Apple ID settings': '可在Apple ID的設置中管理會員權限',
  'Free': '免費',
  'Annual': '年度',
  'Monthly': '月度',
  'Quarterly': '季度',
  'Perpetual': '長久有效',
  'Giveaway': '贈品',
  'Cancel subscription': '取消訂閱',
  'Current Plan': '當前會員',
  'Renews': '續费時間',
  'Expire on': '到期時間',
  'VIP Duration': 'VIP時長',
  'Month': '個 月',
  'Months': '個 月',
  'Activate': '激活',
  'Use Across Devices': '可用設備',
  'As you already have a subscription plan, activating the "Giveaway" plan would make both plans run on your account, but it will not increase the original subscription time. Are you sure you want to activate the "Giveaway" plan?': '由於您已有訂閱會員，故激活“贈品”會員后您將同時使用兩個會員，但不會增加原始訂閱會員的時長。 您也可以選擇原有訂閱會員到期后，再選擇激活這 個 “贈品”會員，以獲得更長期限的會員權益。您確定要激活“贈品”會員嗎？',
  'Activate the "Giveaway" plan': '激活“贈品”會員',
  'Password management': '密碼管理',
  'You can set password if you don\'t prefer logging in with codes.': '可設置一個登入密碼用於登入賬號',
  'Change Password': '修改密碼',
  'Set Password': '設置登入密碼',
  'Are you sure log out your account?': '確定退出登入嗎？',
  'Log out of UPDF account': '退出登入',
  'You may not be able to use all features after logging out of your account until you log back in.': '退出登入后，將無法使用所有功能',
  'Log Out': '退出',
  'Confirm input error': '確認信息錯誤',
  'Permanently delete your personal information and all data, this operation can\'t be recovered. Enter <span style="color: var(--el-color-primary)">{uid}</span> to confirm the operation.': '永久 刪除您 的個人信息和所有數據，此操作無法恢復。請輸入 <span style="color: var(--el-color-primary)">{uid }</span> 確認刪除',
  'Delete your account': '刪除賬號',
  'Your personal information and all data will be removed permanently and can\'t be recovered.': '永久刪除個人信息和所有數據，此操作無法恢復',
  'Delete': '刪除',
  'The avatar must be an image.': '頭像必須是圖片格式',
  'You will miss the following membership rights when the subscription expired.': '訂閱到期后您將不再享有以下會員權益',
  'Expire on {date}': '您的訂閱將於{date}到期',
  'Redeem': '序列號兌換',
  'Redeem-2': '兌換',
  'The license will be bound to your account, and extend the expiration date.': '通過序列號兌換的會員權益，將和你的賬號綁定，增加你的會員時長。',
  'Please input license.': '請輸入序列號',
  'Incorrect license code.': '無效的序列號',
  'Redeem success.': '兌換成功',
  'Use across Windows, macOS, Android, iOS++No watermark++All annotate tools++Edit PDF text, images and links++Convert PDF to Word, Excel, PPT++OCR Text Recognition++Extract, insert, replace, split pages++Free updates and upgrades': 'Windows、macOS、iOS、Android平台通用++無水印存檔++所有註釋工具++編輯PDF正文、圖片和鏈接++PDF文件轉換為Word、Excel、PPT++OCR 文本識別++ 頁面提取、插入、替換、拆分++訂閱期內免費更新',
  'Keep UPDF Pro': '繼續訂閱',
  'Continue Cancellation': '取消續訂',
  'Renew': '立即續訂',
  'Activate Subscription': '恢復訂閱',
  'Success! Your UPDF PRO subscription will be renewed on {date}': '恢復成功! 你的UPDF會員 將會在{date}重新訂閱',
  'Upgrade to Pro': '升級到專業版',
  'Please enter the new mobile phone number': '請輸入新的手機號',
  'Please enter a valid mobile phone number': '請輸入有效的手機號碼',
  'Please enter a new email address': '請輸入新的郵箱',
  'Please enter a valid email address-2': '請輸入有效的郵箱',
  'Verification code error': '驗證 碼錯誤',
  'Set': '設置',
  'Change': '修改',
  'Link': '綁定',
  'Unlink': '解綁',
  'not set': '未設置',
  'not set-2': '未綁定',
  'Phone Number': '手機號',
  'Google': 'Google',
  'Apple ID': 'Apple ID',
  'Set Phone Number': '設置電話號碼',
  'Please enter the phone number and verification code.': '請輸入電話號碼和驗證碼',
  'Set Email': '設置郵箱',
  'Please enter the email and verification code.': '請輸入郵箱和驗證碼',
  'Please enter the phone number': '請輸入電話號碼',
  'Please enter your email': '請輸入郵箱',
  'Verification code': '驗證碼',
  'Send code': '發送驗證碼',
  'Resend-2': '重新發送',
  'please enter the verification code': '請輸入驗證碼',
  'Please use wechat to scan the QR code and follow the official account binding': '請 使用微信掃描二維碼並 關注公眾號綁定',
  'To keep your account safe': '為保證您的 帳戶 安全',
  'Please enter the verification code sent to': '請輸入發送到的驗證碼',
  'Linked Accounts': '賬號綁定',
  'Binding success': '綁定成功',
  'linked': '已綁定',
  'Unbind successfully': '解綁成功',
  'Unbinding failure': '解綁失敗',
  'Are you sure you want to untie them': '您確定要解綁嗎?',
  'UCloud Expires On': '雲權益到期時間',
  'UPDF Plan': 'UPDF 會員',
  'Full access to all UPDF features and UCloud benefits.': '可使用 UPDF 所有功能和 UPDF Cloud 會員權益',
  'Full access to all UPDF features and comes with 1-year UCloud benefits.': '完全擁有 UPDF 會員權益和一年雲權益',
  'Upgrade to UPDF Pro to get all UPDF features and UCloud benefits.': '升級為 UPDF 會員，可解鎖更多 UPDF 功能和 Cloud 權益',
  'Full access to all UPDF features.': '完全擁有 UPDF 會員權益',
  'Create a Company': '創建企業',
  'Please fill in the company information': '請填寫企業真實信息',
  'Company Name': '請輸入企業名稱',
  'Industry Type': '請選擇行業類型',
  'Number of Employees': '請選擇人員規模',
  'Set up enterprise account': '設置企業 帳號',
  'Confirm your enterprise account. You will become the administrator with full management rights.': '請確認你的企業登入帳號 ，該帳號將成為企業管理員，擁有全部管理權限',
  'Email Address': '請輸入你的郵箱地址',
  'Email Address or Phone Number': '請輸入你的郵箱地址或手機號碼',
  'Please enter the password of {companyName}': '請輸入{companyName }的 帳戶 密碼',
  'Your company is created successfully.': '你的企業已成功創建',
  'Invite members to join the company by email or by copying the link.': '可通過郵件或複製鏈接，邀請成員加入企業',
  'Invite members': '邀請成員加入企業',
  'Invite Later': '稍後邀請',
  'Send Invitation': '發送邀請',
  'Copy Link': '複製鏈接',
  'UPDF PRO': 'UPDF會員',
  'Your account now has full access to all features without limits.': '你的 帳號 可無限制的使用所有UPDF功能',
  'Your account has not been authorized by the administrator': '你的 帳號 尚未被管理員授權',
  'All': '所有',
  'Authorized': '已授權',
  'Unauthorized': '未授權',
  'Company Logo': '企業Logo',
  'Contact Information': '聯繫人信息',
  'Administrator': '管理員',
  'Email-1': '聯繫郵箱',
  'Phone Number-1': '聯繫手機',
  'Transfer': '轉讓',
  'Permanently delete your company information and all data, this operation can not be recovered. Enter <span style="color: var(--el-color-primary)">{companyId}</span> to confirm the operation.': '永久刪除您 的企業信息和所有數據，此操作無法恢復。請輸入<span style="color: var(--el -color-primary)">{companyId }</span>（企業ID）確認刪除',
  'Assigned': '已分配',
  'Quick Entry': '快捷入口',
  'Last Login Time': '最後登入時間',
  'Operation': '操作',
  'Search': '查詢',
  'Link copied': '鏈接複製成功',
  'Email, separated by enter': '請輸入郵箱地址，多個郵箱用Enter鍵分隔',
  'This email is already on the list': '該郵箱已在列表中',
  'Invalid Invite Code': '邀請 碼錯誤',
  'You have joined the company.': '你已加入該企業',
  'The following accounts are bound to the current login method. Please select the account to log in.': '當前登入方式綁定了以下帳號 ，請選擇帳號登入',
  'Enter password': '輸入密碼',
  'Please enter the password of <span>{username}</span>': '請輸入 <span>{username}</span> 的賬戶密碼',
  'This account is already logged in': '該賬號已經登入',
  'You have successfully joined {companyName}': '您已成功加入【{companyName }】',
  'Download UPDF now to share membership benefits': '馬上下載 UPDF，共享會員權益',
  'Download UPDF': '下載 UPDF',
  'Please Enter..': '請輸入..',
  'Full Name': '姓名',
  'Please login first': '請先登入',
  'administrator': '管理員',
  'Dissolve Company': '解散企業',
  'Permanently delete your business information and data. This action is non-recoverable. Enter <span style="color: var(--el-color-primary)">{companyId}</span> to confirm.': '永久 刪除您 的企業信息和所有數據，此操作無法恢復。請輸入（<span style="color: var(--el -color-primary)">{companyId }</span>）確認刪除',
  'Accommodation and Food Services': '住宿和餐飲業',
  'Administration, Business Support, and Waste Management Services': '水利、環境和公共設施管理業',
  'Agriculture, Forestry, Fishing, and Hunting': '農、林、牧、漁業',
  'Arts, Entertainment, and Recreation': '文化、體育和娛樂業',
  'Construction': '建築業',
  'Educational Services': '教育',
  'Finance and Insurance': '金融業',
  'Healthcare and Social Assistance': '衛生和社會工作',
  'Information and Communication': '信息傳輸、軟件和信息技術服務業',
  'Manufacturing': '製造業',
  'Mining': '採礦業',
  'Other Services': '其他',
  'Professional, Scientific, and Technical Services': '科學研究和技術服務業',
  'Real Estate, Rental, and Leasing': '租賃和商務服務業',
  'Wholesale and Retail Trade': '批發和零售業',
  'Transportation and Warehousing': '交通運輸、倉儲和郵政業',
  'Utilities': '公共管理、社會保障和社會組織',
  'Order No.': '訂單編號',
  'Amount': '金額',
  'Product': '商品',
  'Payment Time': '支付時間',
  'Payment Status': '支付狀態',
  'Your order is being processed. It may take from 2 to 6 working days to process your payment using the payment method of Sofort/Pix/Boleto. You will be informed via email once the process is done.': '您的訂單正在處理中。 使用Sofort/Pix/Boleto等付款方式處理您的付款可能需要2至6個工作天。 一旦處理完成，我們將透過電子郵件通知您。',
  'Unpaid': '未支付',
  'Failure': '失敗',
  'Paid': '已支付',
  'Refunded': '已退款',
  'Pending': '支付中',
  'Expire on:': '過期時間：',
  'Card Expired': '卡片已過期',
  'The payment card can only be changed for orders under subscription. For canceled orders, the renewal has been cancelled, and the payment card cannot be changed. If you need to change the payment card, please renew the subscription of this order in "Subscriptions" first.': '僅可變更已訂閱訂單的付款卡。 對於已取消的訂單，續訂已被取消，無法更改支付卡。 如果需要更改支付卡，請先在「訂閱」中重新訂閱對應plan',
  'Canceled': '已取消',
  'Change Card': '更改卡片',
  'Active': '可用的',
  'Inactive': '不活躍的',
  'Credit cards associated with subscription orders can be managed here. Here you can modify the credit card that will be used for future renewals. To cancel or restore a subscription, please operate in "Subscriptions".': '與訂閱訂單關聯的信用卡可以在此處管理。 您可以修改將來續費所使用的信用卡。 若要取消或恢復訂閱plan，請在「訂閱」中操作。',
  'Security': '安全',
  'Payment Management': '支付管理',
  'Order Information': '訂單資訊',
  'Pay Again': '重新購買',
  'Change successfully': '修改成功',
  'Change failed, please try again': '修改失敗，請重試',
  'Order information only includes orders purchased through the website. Applepay and Google Play orders will not be displayed.': '訂單資訊僅包括透過官網購買的訂單。 Applepay 和 Google Play 訂單將不會顯示',
  'Membership': '會員',
  '(Educational)': '(教育版)',
  'Issue an invoice': '開立發票',
  'Download invoice': '下載發票',
  'Bill To:': '帳單：',
  'Name': '姓名',
  'Address': '地址',
  'ZIP Code': '郵遞區號',
  'Submit': '提交',
  'Please check the information carefully. It cannot be modified after submission. Are you sure to submit?': '請仔細核對訊息，提交後不可修改。 確認提交？',
  'Are you sure?': '確定提交？',
  'Invoice Information': '發票資訊',
  'Must enter 1-20 characters': '必須輸入1-20個字符',
  'Must enter 1-100 characters': '必須輸入1-100個字符',
  'Must enter 1-500 characters': '必須輸入1-500個字符',
  'Must enter 1-200 characters': '必須輸入1-200個字符',
  'Must enter 1-50 characters': '必須輸入1-50個字符',
  'Device Management': '設備管理',
  'Desktop': '客戶端',
  'Last active': '最後活躍',
  'Login out': '登出',
  'Mobile': '行動端',
  'After being removed, the device will automatically log out and needs to be logged in again. Do you confirm the operation?': '移除後，裝置會自動登出，需要重新登入。 你確認操作嗎？',
  'Settings': '設置',
  'Avatar': '頭像',
  'Sign Out': '登出',
  'Join Time': '加入企業時間',
  'Remove Member': '移除成員',
  'Deauthorize': '取消授權',
  'Authorize': '授權',
  'Authorization': '授權狀態',
  'Company Overview': '企業概況',
  'Redeem-3': '兌換授權',
  'Buy Licenses': '購買授權',
  'Member Management': '成員管理',
  'Deleted Successfully': '刪除成功',
  'Deauthorized Successfully': '取消授權成功',
  'Authorized Successfully': '授權成功',
  'Redeemed successfully': '兌換成功',
  'Company Settings': '企業設置',
  'Company Infomation': '企業信息',
  'The invitation has been sent successfully': '邀請已成功發送',
  'Incorrect format of email': '聯繫郵箱格式不正確',
  'Incorrect format of phone number': '聯繫電話格式不正確',
  'Dissolved successfully': '解散成功',
  'License View': '授權視圖',
  'Member View': '成員視圖',
  'Total Licenses': '授權總數',
  'Total Members': '成員總數',
  'Reset': '重置',
  'Number of Members': '企業規模',
  'Company ID': '企業ID',
  'No staff selected': '未選擇成員',
  'Please enter the email': '請輸入聯繫郵箱',
  'Add Member': '邀請成員',
  'Please enter the company name': '請輸入企業名稱',
  'Permanently delete your business information and data. This action is non-recoverable.': '永久 刪除您 的企業信息和所有數據，此操作無法恢復。',
  'Skip': '跳過',
  'You are not an administrator and do not have permission to access this page.': '你不是管理員，沒有訪問這個頁面的權限',
  'Enterprise management': '企業管理',
  'Flexible configuration, tracking, and management of licenses within your company.': '在公司範圍內靈活的設置、跟蹤和管理UPDF授權',
  'Enterprise management dashboard': '企業管理後台',
  'Authorization failed': '授權失敗',
  'Buy Now': '購買',
  'Buy': '購買',
  'Insufficient licenses available! Want to buy more licenses?': '可用授權不足，是否購買更多授權？',
  'Privilege grant failed': '授權失敗',
  'Number of Users': 'Number of Users',
  'Member Avatar': '用戶頭像',
  'Password must be 6-20 characters, and should have numbers, English letters, or symbols.': '密碼必須為6-20位字符，支持数字、英文字母或符號',
  'Not set': '未設置',
  'The current account is the administrator of {companyName}, please log in to the enterprise management platform and dissolve the company to complete the deletion.': '當前帳號是{companyName }的企業管理員，請登入企業管理後台並解散企業，即可刪除帳號',
  'Permanently and irreversibly delete the member\'s account and all data. Click OK to complete the deletion': '永久刪除該成員 帳號 和所有數據，此操作不可恢復。點擊確認刪除',
  'Got it': '我知道了',
  'CompanyId Error': '企業Id錯誤',
  'Select': '請選擇',
  'Enterprise management background': '企業管理後台',
  'Authorized employees': '已授權員工',
  'Authorized members': '授權使用數',
  'The current account already has a perpetual plan. If you need to redeem it again, please change to another account.': '當前 帳號 已是終身會員，如需再次兌換，請更換 帳號',
  'Number of redemption licences': '兌換的數量',
  'Invalid redemption code': '兌換 碼錯誤',
  'Allocation of Licence Quotas (Number of employees with licences/Total number of licences)': '授權名額分配情況（已分配權益的員工數/權益總名額）',
  'Authorization of Employee Status (Number of employees with licences/Total number of employees)': '企業員工授權情況（已分配權益的員工數/員工總數）',
  'All the selected enterprise users will be permanently deleted. Do you want to continue?': '所選中的企業用戶會被永久性刪除，要繼續嗎？',
  'Share Invitation': '分享邀請',
  'Add Manually': '手動添加',
  'Batch Import': '批量導入',
  'Export All Member': '導出所有成員',
  'Export Selected Member': '導出選中的成員',
  'Account: required. 6-60 characters. The account can not be repeated. It supports numbers, English letters and English symbols.': '帳號 ：必填，6-60個字符，不可重複，支持数字、英文字母和英文符號',
  'Name: required. The length is limited to 60 characters.': '姓名：必填，60個字符以內',
  'Password: optional. 6-20 characters. It supports numbers, English letters and English symbols.': '密碼：非必填，6-20個字符，支持数字、英文字母和英文符號',
  'Mobile phone number: optional. Phone number format.': '手機號碼：非必填，格式為手機格式',
  'Whether to authorize: optional. Please fill in [Yes], [No]. If not filled, the default is [No].': '是否授權：選填，請填入[是]、[否]，不填則默認為[否]',
  'Uploaded Failed': '上 傳失敗',
  'The content is wrong. Please modify and reupload.': '內容填寫錯誤，請修改 后重新上傳',
  'Uploaded Succeed!': '上 傳成功',
  'Employee Table Template.xlsx': '員工表格模板',
  'You can click to download the Employee table template and fill out the table': '請下載模板並填寫表格',
  'Copy the following information and notify the user to log in.': '複製以下信息並通知用戶登陸',
  'Must be letters, digits or symbols': '必須是字母数字符號',
  'Please contact administrator to reset password': '請聯繫管理員重置密碼',
  'Please enter account/email/phone number': '請輸入 帳號 /郵箱/手機號',
  'Please enter an effective account/email/phone number': '請輸入有效的 帳號 /郵箱/手機號',
  'Please enter account/email': '請輸入 帳號 /郵箱',
  'Please enter an effective account/email': '請輸入有效的 帳號 /郵箱',
  'Drag the template here, or <em>click to upload</em>': '拖拽模板至此，或<em >點擊上傳</em >',
  'Account_1': '帳號',
  'Inactivated': '未激活',
  'Activated': '已激活',
  'Deleted': '已註銷',
  'Register & log in UPDF account You can convert <span>2 files for FREE</span>': '註冊登入即可獲得<span>2次免費</span>轉換權益',
  'Register & log in UPDF account You can convert <span>2 files per day</span>for FREE': '註冊登入即可獲得<span>每日2次免費</span>轉換權益',
  '{{.shareName}} added you to {{.companyName}}': '{{.shareName }}邀請你加入了{{.companyName }}',
  '{{.shareName}} added you to {{.companyName}}. You can share UPDF membership benefits now. The account information is as follows. Remember to save it and log in.': '{{.shareName }}邀請你加入了{{.companyName }}。你可以共享UPDF會員權益。以下是帳號信息，請保存並登入查看。',
  'Password': '密碼',
  'Full name': '姓名',
  'Your password has been reset': '你的密碼已重置',
  'Your password has been reset by the administrator. The account information is as follows. Remember to save it and log in.': '你的密碼已被管理員重置，以下是帳號信息。請保存並登入查看。',
  'Upload the filled out template:': '上傳',
  'Please enter account': '請輸入帳號',
  'Please enter password': '請輸入密碼',
  'Must enter 6-20 characters': '必須輸入6-20字符',
  'Please enter 1-30 characters': '請輸入1-30字符',
  'Must enter 1-30 characters': '必須輸入1-30字符',
  'Please enter email': '請輸入郵箱',
  'Please enter an effective email': '請輸入有效的郵箱',
  'Please enter phone number': '請輸入手機號',
  'Copy': '複製',
  'Only one file can be uploaded': '只能上傳一個文件',
  'Accounts can not be repeated. Only numbers, letters, and symbols are supported; it is recommended to name accounts with numbers or letters plus a company suffix (for example: abc@updf, 0100@updf) to ensure uniqueness.': '帳號 不可重複，支持数字、英文字母和英文符號；建議將員工 帳號 以数字或字母加企業後綴的方式命名（例：abc@updf ，0100@updf），保證唯一性',
  'Reason of failure:': '導入失敗原因',
  'Information copied': '信息已複製',
  'Message sent': '信息已發送',
  'The file can not exceed 10MB': '文件大小不能超過10MB',
  'Must enter 6-60 characters': '必須輸入6-60字符',
  'The file exceeds the limit of 30,000 lines, please modify and upload again': '文件超過30000行限制，請修改 后重新上傳',
  'Support format': '支持格式',
  'Send a message to notify the user to log in': '發送通知提示用戶登陸',
  'Please enter email/phone number': '請輸入郵箱/手機號',
  'Please enter an effective email/phone number': '請輸入有效的郵箱/手機號',
  'Added successfully': '添加成功',
  'Member Info': '成員信息',
  'Send': '發送',
  'The company name only supports Chinese characters': '企業名稱僅支持漢字',
  'http_error_4023': '該兌換碼為企業兌換碼，請到企業管理後台兌換',
  'E-mail: optional. Email format.': '郵箱：非必填，格式為郵箱格式，不可重複',
  'Phone number: optional. Phone number format.': '手機號碼：非必填，格式為手機格式，不可重複',
  'Enterprise name': '企業名稱',
  'Redeem Now': '立即兌換',
  'Auto-redemption': '自動兌換',
  'You have purchased the Enterprise Plan. Do you want to auto-redeem your plan?': '你已購買企業版會員，是否自動兌換？',
  'Later': '稍後',
  'Redemption code': '兌換碼',
  'Users': '用戶',
  'It is an enterprise license code, please go to Enterprise Management Dashboard to redeem it.': '該兌換碼為企業兌換碼，請到企業管理後台兌換',
  'Open UPDF': '打開UPDF',
  'Personal Account': '個人 帳號',
  'Enterprise Account': '企業 帳號',
  'Language Settings': '語言設置',
  'Language': '語言',
  'Click "Open UPDF" to automatically log in to the enterprise account.': '點擊「打開UPDF」，可以自動登入企業 帳號',
  'Click "Enterprise Management Dashboard", you can enter the Management Dashboard to redeem plan, set enterprise information, invite members to join the enterprise, and conduct enterprise management.': '點擊「企業管理後台」，可以進入管理後台兌換權益，設置企業信息，邀請成員加入企業，進行企業管理',
  'Company': '企業',
  'Please enter your purchased UPDF redemption code, the successful redemption will increase the number of authorized licenses for the company.': '請輸入你購買的UPDF兌換碼，成功兌換後會增加企業授權數量',
  'Click to Accept': '確認加入',
  'Dissolve success': '解散成功',
  'Upload files up to 100 per month': '支持上傳文件數：100個文件/月',
  'Up to 1000 pages per file': '每個文件頁數 <= 1000',
  'Ask questions up to 1000 times per month': '提問次數：1000次/月',
  'Up to 2GB per file': '單文件 大小限製為2GB',
  '10GB of FREE ADDITIONAL STORAGE': '附贈10GB 雲空間',
  'You have unlocked advanced AI features': '您已解鎖高級AI功能',
  'UPDF AI Pro Plan': 'UPDF AI Pro權益',
  'Upgrade': '升級',
  'Upgrade to UPDF AI Pro monthly Plan to unlock more AI features': '升級為 UPDF AI 會員，可解鎖更多 AI 功能',
  'Full access to all UPDF AI features and UPDF Cloud benefits': '已獲取全部UPDF AI功能和UPDF雲權益',
  'Success! Your UPDF AI PRO subscription will be renewed on {date}': '恢復成功! 你的UPDF AI會員 將會在{date}重新訂閱',
  'Keep UPDF AI Pro': '繼續訂閱',
  'Continue with Apple': '使用 Apple 登入',
  'Continue with Google': '使用 Google 登入',
  'You can also <span>continue with SSO</span>': '您還可以<span>使用SSO</span>',
  'Operation successful': '操作成功',
  'Operation failed, please try again': '操作失敗，請重試',
  'Super Admin information': '超管理員資訊',
  'Transfer super Admin': '轉讓超級管理員',
  'Confirm to transfer super Admin?': '確認轉讓超級管理員？',
  'You will automatically log out of the management backend interface after the transfer': '轉讓後將自動登出管理後台介面',
  'Organization management': '組織管理',
  'Super Admin can add 5 ordinary Admin; ordinary Admin have all the operation rights of the management backend, except the following functions: transfer super Admin; add and remove ordinary Admins; dissolve the company.': '超級管理員可以新增5名普通管理員；普通管理員擁有管理後台的所有操作權限，除了以下功能：轉讓超級管理員；新增、移除普通管理員；解散企業',
  'Add Admin': '新增管理員',
  'Admin list': '管理員列表',
  'Please enter the employee\'s account': '請輸入員工帳號',
  'Confirm to remove Admin?': '確認移除管理員？',
  'After removal, the employee will not be able to enter the management backend': '移除後該員工將不可進入管理後台',
  'Duplicate addition': '重複添加',
  'Super admin cannot be added as a normal admin': '超級管理員不可被加入為普通管理員',
  'The super admin removes you from the admin of {{.companyName}}. You can continue to use the enterprise account, but you no longer have the authority to manage the enterprise. If you have any questions, please communicate with the super admin in time.': '超級管理者將你從 {{.companyName}} 的普通管理員移除。你可以繼續使用企業帳號，但不再擁有管理企業的權限。有任何疑問請及時與超級管理員溝通。',
  'The super admin adds you as a admin of {{.companyName}}. You can log in to the enterprise management backend to manage the enterprise. The admin\'s account password is your UPDF enterprise account password.': '超級管理員將你加入為 {{.companyName}} 的普通管理員。你可以登入企業管理後台，管理企業。管理員的帳號密碼為你的UPDF企業帳號密碼。',
  '{{.shareName}} transfers the super administrator of {{.companyName}} to you. You can log in to the enterprise management backend to manage the enterprise. The administrator\'s account password is your UPDF enterprise account password.': '{{.shareName}} 將 {{.companyName}} 的超級管理者轉讓給你。你可以登入企業管理後台，管理企業。管理員的帳號密碼為你的UPDF企業帳號密碼。',
  'Enterprise management dashboard:': '企業管理後台:',
  'Notification of transferring enterprise super admin': '轉讓企業超級管理員通知',
  'Notification of adding enterprise admin': '新增企業管理員通知',
  'Notification of removing enterprise admin': '移除管理員通知',
  'Administrators cannot be deleted': '不能刪除管理員',
  'A maximum of 5 normal administrators can be added': '最多新增5名普通管理員',
  'UPDF AI Unlimited': 'UPDF AI 無限版',
  'UPDF AI Standard': 'UPDF AI 標準版',
  'UPDF AI Plan': 'UPDF AI 會員',
  'Upload files unlimited per month++Up to 1000 pages per file++Ask questions unlimited times per month++Up to 2GB per file++100GB of FREE ADDITIONAL STORAGE': '每月上傳無限量檔案++每個檔案最多 1000 頁++每月無限次提問++每個檔案最多 2GB++100GB 免費額外儲存空間',
  'Success! Your {aiType} subscription will be renewed at {money} on {date}': '成功！ 您的 {aiType} 訂閱將於 {date} 按 {money} 續訂',
  'Success! Your UPDF PRO subscription will be renewed at {money} on {date}': '成功！ 您的 UPDF PRO 訂閱將於 {date} 按 {money} 續訂',
  'Thank you for being with us—enjoy a special offer before you go.': '為了感謝您一直以來的支持，我們為您提供了一個專屬優惠！',
  'Your plan: <span> {planName} </span>': '您目前的訂閱方案：<span> {planName} </span>',
  'Regular price: <span>{planSubscriptionMoney} / {planType}</span> → <span>{planDiscountSubscriptionMoney} / {planType}</span>': '常規價格：<span>{planSubscriptionMoney} / {planType}</span> → <span>{planDiscountSubscriptionMoney} / {planType}</span>',
  'You can still cancel anytime. Would you like to stay at this discounted rate?': '您仍可隨時取消訂閱。是否願意以優惠價格繼續使用我們的服務？',
  'Stay and Save {discount}%': '保持訂閱享受 {discount}折',
  '{discount}% OFF': '{discount}折',
  'Keep UPDF AI Unlimited': '保持 UPDF AI 無限版',
  'Keep UPDF AI Standard': '保持 UPDF AI 標準版',
  'Organizational License View': '組織授權視圖',
  'Unlimited': '無限制',
  'Your company membership benefits will expire in {organizeExpiredTime} days and all membership benefits will be unavailable. Please contact UPDF sales promptly to renew your membership.': '您的公司會員權益將在 {organizeExpiredTime} 天後到期，屆時所有會員權益將無法使用。 請及時聯絡 UPDF 銷售續約您的會員資格。',
  'Your company\'s membership rights have expired and all membership rights are no longer available. Please contact UPDF sales today to renew your membership.': '您的企業套餐已過期，所有會員權益均已失效。請立即聯絡 UPDF 銷售團隊續訂您的會員資格。',
  'Function Settings': '功能設定',
  'Enterprise cloud management': '企業雲端管理',
  'Enterprise AI management': '企業AI管理',
  'Turn off': '關閉',
  'Trun on': '打開',
  'When the function is turned on, employees can use the cloud function; when it is turned off, the cloud function is turned off and employee accounts can only use local files and cannot upload them to the cloud. This feature is enabled by default.': '功能開啟時，員工可以使用cloud功能；關閉後，cloud功能關閉，員工帳號只能使用本機文件，不可上傳至雲端。 此功能預設開啟。',
  'After closing, all Cloud functions under the employee account will be closed, and all files uploaded to the Cloud will be inaccessible. Are you sure?': '關閉後，員工帳號下所有Cloud功能將被關閉，已上傳至Cloud的文件將全部不可訪問，確認操作？',
  'After closing, all Cloud functions under the employee account will be closed, and all files uploaded to the Cloud will be inaccessible. Since the AI function requires the Cloud to be turned on before it can be used, if you turn off the Cloud, the AI switch will be turned off at the same time. Are you sure?': '關閉後，員工帳號下所有Cloud功能將關閉，已上傳至Cloud的檔案將全部無法存取；由於AI功能需要開啟Cloud才可使用，關閉Cloud將使AI開關同時關閉，確認操作？',
  'Once enabled, all Cloud functions under the employee account will be enabled, and files can be uploaded to Cloud. Are you sure?': '開啟後，員工帳號下方所有Cloud功能將開啟，可將檔案上傳至Cloud，確認操作？',
  'When the function is turned on, employees can use AI; when it is turned off, the AI function is turned off. This function is a paid function. If you want to use AI, please contact sales': '功能開啟時，AI功能入口開放並可試用；關閉後，AI功能入口隱藏。如需使用AI會員請聯絡銷售',
  'After closing, all AI functions under the employee account will be closed, and all generated AI conversation content will be inaccessible. Are you sure?': '關閉後，員工帳號下所有AI 功能將關閉，已產生的AI對話內容將全部不可訪問，確認操作？',
  'After it is enabled, all AI functions under the employee account will be enabled. Are you sure?': '開啟後，員工帳號下所有AI功能將開啟，確認操作？',
  'This function is a paid function. If you want to use AI membership, please contact sales.': '此功能為付費功能，如需使用AI會員請聯絡銷售',
  'Using the AI ​​function requires uploading documents to the Cloud. Please turn on the Cloud function first before turning on the AI ​​switch.': '使用AI功能需要將文件上傳至Cloud。 請先將Cloud功能打開，才可以打開AI開關',
  'I know': '我知道了',
  'Company User': '企業人數',
  'Company UPDF Licenses': '企業版 UPDF 權益',
  'Company AI Licenses': '企業版 UPDF AI 權益',
  'UPDF': 'UPDF',
  'Use Of State': '使用狀態',
  'Residue': '剩餘',
  'More Operations': '更多操作',
  'Buy UPDF Licenses': '購買 UPDF 權益',
  'Buy AI Licenses': '購買 UPDF AI',
  'UPDF Authorize': 'UPDF授權',
  'AI Authorize': 'AI授權',
  'UPDF AI': 'UPDF AI',
  'UPDF Deauthorize': 'UPDF取消授權',
  'AI Deauthorize': 'AI取消授權',
  'UPDF AI Authorize': 'UPDF AI授權',
  'Approval Management': '審核管理',
  'Order Number': '訂單編號',
  'ProductUPDF': '產品',
  'Number': '編號',
  'Created at': '創建於',
  'Payment Method': '付款方式',
  'Money': '金額',
  'Subscription': '訂閱',
  'No Subscription': '無訂閱',
  'UPDF Lifetime': 'UPDF 終身',
  'AI Annual': 'AI 年度',
  'Non payment': '未付款',
  'payment failure': '付款失敗',
  'cancel Subscribing': '取消訂閱',
  'Subscribing': '訂閱中',
  'Orders': '訂單',
  'Create a personal account': '建立個人帳號',
  'CompanyAccount': '帳號',
  'Unauthorized employee': '未授權員工',
  'Authorized employee': '已授權員工',
  'Order': '訂單',
  'Amount of AI plans to be redeemed': '兌換的AI會員數量',
  'Amount of UPDF plans to be redeemed': '兌換的UPDF會員數量',
  'Pay time': '支付時間',
  'Quantity': '數量',
  'Payment status': '支付狀態',
  'Active Status': '激活狀態',
  'Insufficient licenses available！Please contact sales.': '可用授權不足，請聯絡銷售人員',
  'Please contact the administrator to obtain authorization so that you can use advanced features.': '請聯絡管理員取得授權，進而使用進階功能。',
  'Administrator Information': '管理員資訊',
  'Transfer Administrator': '轉讓管理員',
  'Are you sure to transfer the administrator?': '是否確定轉讓管理員？',
  'You will be automatically logged out of the Enterprise Management Dashboard after transfering the administrator. The new administrator can directly log in Management Dashboard through his account and password.': '轉讓後您將自動登出管理後台。新管理員可以透過其的帳號密碼直接登入管理後台',
  'Account binding': '帳號綁定',
  'Please enter your email address and verification code': '請輸入信​​箱和驗證碼',
  'Please input your email': '請輸入信​​箱',
  'Invalid verification code, please try again': '無效驗證碼，請重試',
  'Current version': '目前版本',
  'Check for upgrades': '檢查更新',
  'The current version is already the latest version': '目前版本已經是最新版本',
  'Upgrade immediately': '立即升級',
  'Send verification code': '發送驗證碼',
  'Account or password error': '帳號或密碼錯誤',
  'Please contact the administrator to reset the password': '請聯絡管理員重設密碼',
  'Please enter the administrator\'s email': '請輸入管理員信箱',
  'Please enter the 4-digit verification code sent to {account}. <br>Valid for 10 minutes.': '請輸入發送至<br>{account}的 4 位元驗證碼，有效期限 10 分鐘',
  'Private Enterprise Account': '私有化企業用戶',
  'This software is about to be downloaded to the server, are you sure?': '用戶端即將下載至本服務端，是否確認？',
  'The server will be upgraded, are you sure?': '服務端將升級，是否確認？',
  'Confirm Upgrade': '確認升級',
  'Checking...': '查找...',
  'Server Upgrade': '服務端升級',
  'Software Upgrade': '客戶端升級',
  'The upgrade needs to be connected to the Internet, and the latest server configuration can be obtained': '升級需要聯網，可取得最新服務端配置',
  'Operation failed. Please try again after the server is connected to the Internet': '操作失敗，請在伺服器聯網後重試',
  'Operation failed. Please try again after connecting to the local area network': '操作失敗，請連線區域網路後重試',
  'No permission. You are about to be automatically logged out': '沒有權限，即將自動登出',
  'Insufficient license is available! Contact sales to buy more.': '可用授權不足！ 聯絡銷售人員購買更多。',
  'Your annual plan has {expireTime} days to expire, please contact sales to purchase perpetual plan.': '您的年度會員權益還有{expireTime}天到期，請聯絡銷售購買終身權益。',
  'Password has been reset successfully. Please use the new password to log in.': '密碼重設成功，請使用新密碼登入。',
  'This email is used to reset the administrator password: when the administrator forgets the password, click "forgot password" on the login interface, and a verification code can be sent to this email to reset the password (the verification code needs to be connected to the Internet to receive it). When the administrator is transferred, the email will be changed accordingly, and the new administrator can also bind a new email.': '此郵箱用於重置管理員密碼：當管理員忘記密碼時，在登入介面點擊“忘記密碼”，即可向此郵箱發送驗證碼重設密碼（接收驗證碼需要網路連線）。當管理員調動時，郵件信箱會相應變更，新管理員也可綁定新的信箱。',
  'Your version is already the latest version': '您的版本已經是最新版本。',
  'The upgrade needs to be connected to the Internet, and the latest software configuration can be obtained': '升級需要聯網，可取得最新客戶端端配置',
  'Change binding': '更改綁定',
  'Privatized Enterprise Account': '私有化企業',
  'Enterprise Management Dashboard': '企業管理後台',
  'When upgrading, all client software will be suspended, please remind employees to save in time': '升級時，所有客戶端軟體將暫停，請提醒員工及時保存。',
  'Upgrade failed, please try again': '升級失敗，請重試',
  'http_error_4024': '兌換碼是個人類型，在企業類型兌換無法使用',
  'http_error_4408': '網路連結逾時，需連接互聯網',
  'This version includes bug fixes and performance improvements': '這個版本包括修復漏洞和效能提升',
  'UPDF Annual': 'UPDF 年度',
  'Success! Your subscription will be renewed on {data}': '成功了！您的訂閱將於 {data} 續訂',
  'You will miss the membership rights when the subscription expired.': '訂閱到期後，您將失去會員權利。',
  '⏰ <span>Expire on</span> {data}': '⏰ <span>到期日</span> {data}',
  'Keep Subscribing': '繼續訂閱',
  'Active Subscription': '啟用訂閱',
  'UPDF Sign Annually': 'UPDF 數位簽名',
  'UPDF Sign Monthly': 'UPDF 數位簽名',
  'Sign': '數位簽名',
  'UPDF Sign': 'UPDF 數位簽名',
  'Your account now has full access to all UPDF Sign features.': '您的帳戶現在可以完全存取所有 UPDF 數位簽名功能',
  'Full access to all UPDF Sign features and UPDF Cloud benefits.': '完全存取所有 UPDF 數位簽章功能和 UPDF 雲端權益',
  'UPDF Sign Authorize': 'UPDF 簽名授權',
  'Buy Sign Licenses': '購買 Sign 許可證',
  'Amount of Sign plans to be redeemed': '要兌換的 Sign 會員數量',
  'Sign Authorize': 'Sign 授權',
  'Sign Deauthorize': 'Sign 取消授權',
  'Keep UPDF Sign': '保留 UPDF Sign',
  'Legally binding digital signature (certified by AATL).++Automatically notify recipients when signature is sent.++Multiple file signing and batch sending.++Save and manage digital signatures for long-term use.++Provides audit trail and certification.': '具有法律約束力的數位簽章（經AATL認證）。 ++簽名發送時自動通知收件人。 ++多文件簽章和批次發送。 ++保存和管理數位簽章以供長期使用。 ++提供稽核追蹤和認證。',
  '{number} signature requests per year.': '簽章次數 {}次/{}',
  '{number} signature requests per month.': '簽章次數 {}次/{}',
  'Legally binding digital signature (certified by AATL).': '合法綁定數位簽章（被AATL認證）',
  'Automatically notify recipients when signature is sent.': '發送簽名自動通知簽署者',
  'Multiple file signing and batch sending.': '多文件簽名和批量發送',
  'Save and manage digital signatures for long-term use.': '數位簽名支援管理和長久保存',
  'Provides audit trail and certification.': '提供審計追蹤和證書',
  '20GB cloud storage.': 'Cloud +20G/月',
  '24*7 customer service support.': '7*24客服支持',
  'Register & log in UPDF account You can convert <span>2 files per day</span> for FREE': '註冊並登入 UPDF 帳戶，您可以每天免費轉換<span> 2 個檔案</span>',
  'The annual membership signature quota is unlimited and cannot be modified after authorization to employees. Confirm the authorization?': '年度會員簽名額度無限，授權給員工後不可修改，確認授權？',
  'Authorized employees do not support cancellation. If you need to change, you can contact sales to modify it once.': '已授權員工不支援取消，如需變更可聯絡銷售修改一次',
  'Usage of amount': '額度使用情況',
  'Total signature amount:': '簽名總金額：',
  'Expiration date:': '到期日：',
  'Remaining amount:': '剩餘額度：',
  'Usage of Amount Detail': '額度使用細節',
  'Amount Consumed': '已使用額度',
  'Last Consumption Time': '上次消耗時間',
  'According to the billing process of relevant institutions, we will complete the billing for users every Wednesday': '根據相關機構計費流程，我們將於每週三為使用者完成計費',
  'If you need to create a personal account for use, click here': '如需建立個人帳號使用，可點選此處',
  'Cancelled': '已取消',
  'http_error_403': '無訪問 權限',
  'http_error_408': '請求超時，請重試',
  'http_error_500': '系統錯誤或參數錯誤，請重試',
  'http_error_1401': '驗證失敗，請檢查所填信息',
  'http_error_2001': '帳戶 已存在',
  'http_error_2002': '驗證碼錯誤，請重試',
  'http_error_2003': '驗證碼發送次數太多，請稍後重試',
  'http_error_2004': 'IP登入次數太多，請稍後重試',
  'http_error_2005': '密碼錯誤超過5次',
  'http_error_2006': '登入已過期，請重新登入',
  'http_error_2007': '帳戶 登入次數太多',
  'http_error_2008': '會話異常，請重新登入',
  'http_error_2009': '帳戶未登入，請先登入',
  'http_error_2012': '該帳 號已被綁定，請解綁或刪除賬號后重試',
  'http_error_2403': '帳戶 或密碼錯誤',
  'http_error_2404': '帳戶 不存在',
  'http_error_2411': '郵件發送失敗，請重試或檢查郵箱地址',
  'http_error_4004': '不支持續費',
  'http_error_4005': '序列號已被使用',
  'http_error_4006': '序列號已被廢棄',
  'http_error_4007': '序列號已被下架',
  'http_error_4008': '序列號已被刪除',
  'http_error_4009': '序列號已過期',
  'http_error_4015': '所填 折扣碼不支持 該商品',
  'http_error_4016': '折扣碼超出使用限額',
  'http_error_4019': '商品不存在',
  'http_error_4020': '折扣碼不存在',
  'http_error_4021': '訂單不存在',
  'http_error_4022': '會員不存在',
  'http_error_4026': '兌換碼已失效',
  'http_error_4027': '折扣碼不存在',
  'http_error_4028': '您已經是永久會員，無需兌換。',
  'http_error_4014': '序列號與你的賬號不匹配',
  'http_error_4401': '交易模塊參數驗證錯誤',
  'http_error_4404': '數據不存在',
  'http_error_4502': '請求超時，請重試',
  'http_error_6004': '不能刪除自己',
  'http_error_6001': '自己不能授權自己本身',
  'http_error_6002': '自己不能取消授權自己本身',
  'http_error_6003': '可用授權不足',
  'http_error_6005': '邀請碼已過期',
  'http_error_6506': '導出數據為空',
  'http_error_6507': '導入未完成',
  'http_error_6508': '導入文件為空',
  'http_error_6509': '不是有效Excel',
  'http_error_6012': '郵箱已存在',
  'http_error_6013': '手機號已存在',
  'http_error_6006': '目前企業已被禁用',
  'http_error_2204': '你的訂閱計劃處於激活狀態，刪除 帳戶 前請取消訂閱',
  'UPDF Account Center': 'UPDF 帳號中心',
  'Profile': '個人資訊',
  'Products and Plans': '產品和計劃',
  'Payment and Order': '付款及訂購',
  'Account Settings': '帳戶設定',
  'Account Types': '帳戶類型',
  'Save Changes': '儲存變更',
  'Newsletter Subscription Preferences': '郵件推送訂閱偏好',
  'Subscribe to our newsletter about news, offers and tips.': '訂閱我們的電子郵件，了解產品最新動態及優惠',
  'Redeem License': '兌換序號',
  'You can manage the credit card for your subscription order here. Credit cards are stored by third-party payment institutions, and we at UPDF do not store any credit card information. If you need to unbind, please cancel your subscription in “Product and Plans” first.': '您可以在此管理訂閱訂單的信用卡。信用卡由第三方支付機構存儲，我們 UPDF 不存儲任何信用卡資訊。如需解除綁定，請先在「產品和計畫」中取消訂閱。',
  'Order information only included orders purchased through rhe website. Apple Pay and Google Pay orders will not be displayed here.': '訂單資訊僅包括透過網站購買的訂單。使用 Apple Pay 和 Google Pay 下的訂單不會顯示在這裡。',
  'Card Details': '卡詳細信息',
  'Device Name': '裝置名稱',
  'Location': '地點',
  'Manage': '管理',
  'Linked Account': '關聯帳戶',
  'Status': '狀態',
  'Actions': '操作',
  'No data': '沒有數據',
  'Log in with WeChat Scan': '使用微信登入',
  'Log in with Account/Email/Phone Number': '使用帳號/信箱/手機號碼登入',
  'Registration is successful! Please fill in the following information': '註冊成功！請填寫以下資訊',
  'Get Started': '立即開始',
  'Subscribe to our newsletter, Offers and Tips.': '訂閱我們的電子郵件，了解產品最新動態及優惠',
  'Please verify you are human': '請驗證您是人類',
  'Let us get to know you better': '讓我們更了解您',
  'How do you plan to use UPDF?': '您打算如何使用 UPDF？',
  'For personal use': '供個人使用',
  'For work': '用於工作',
  'For my study or education work': '用於學習或教育事業',
  'How did you hear about us?': '您是如何知道我們的？',
  'Search (Google, Bing, etc.)': '搜尋（Google、Bing 等）',
  'Internet(newsletter, publication, blog etc.)': '網際網路（電子報、出版品、博客等）',
  'Internet ads': '網路廣告',
  'Youtube': 'Youtube',
  'Tiktok': 'TikTok',
  'Social media(Linkedin, Facebook, X, instagram etc.)': '社群媒體（Linkedin、Facebook、X、instagram 等）',
  'From a friend or colleague': '來自朋友或同事',
  'Others(please specify)': '其他（請註明）',
  'Please specify': '請指定',
  'What features do you plan to use with UPDF?': '您計劃使用 UPDF 的哪些功能？',
  'AI': 'AI',
  'Edit PDF': '編輯 PDF',
  'Annotate PDF': '註釋 PDF',
  'Convert PDF': '轉換 PDF',
  'OCR': '光學字元辨識 (OCR)',
  'Create, fill and sign PDFs': '建立、填寫和簽署 PDF',
  'Organize PDF pages': '組織 PDF 頁面',
  'Redact and protect PDFs': '編輯並保護 PDF',
  'I don\'t know yet': '我還不知道',
  'What’s your age group?': '您的年齡層是？',
  'Under 18': '18 歲以下',
  '18-24': '18-24',
  '25-34': '25-34',
  '35-44': '35-44',
  '45-54': '45-54',
  '55-64': '55-64',
  '65 and over': '65 歲及以上',
  'I prefer not to say': '我寧願不說',
  'What kind of work do you do?': '你做什麼工作？',
  'Select your role or job title': '選擇您的角色或職稱',
  '本科在读': '本科在读',
  '硕士在读': '硕士在读',
  '博士在读': '博士在读',
  '教师': '教师',
  'Education (students or education Staff)': '教育（學生或教育人員）',
  'Healthcare': '衛生保健',
  'IT': 'IT',
  'Finance': '金融',
  'Legal': '法律',
  'Creative industries': '創意產業',
  'Engineering': '工程',
  'Goverment and public service': '政府和公共服務',
  'Non-profit and NGOs': '非營利組織和非政府組織',
  'Media and entertainment': '媒體與娛樂',
  'Marketing and advertising': '行銷和廣告',
  'Energy and utilities': '能源和公用事業',
  'Manufacturing_1': '製造業',
  'Real estate': '房地產',
  'Human resource': '人力資源',
  'Telecommunication': '電信',
  'Consulting': '諮詢',
  'Building and construction': '建築和施工',
  'Retired': '已退休',
  'Others': '其他的',
  'Tell us a bit more': '告訴我們更多信息',
  'Next': '下一個',
  'Skip All': '全部跳過',
  'Finish': '結束',
  'Registration is successful!': '註冊成功！',
  'Change Payment Method': '更換支付方式',
  'http_error_1400': '人機驗證失敗',
  'http_error_2400': '郵箱驗證失敗',
  'http_error_6011': '帳號已存在',
  'Feedback': '回饋',
  'Very Dissatisfied': '非常不滿意',
  'Dissatisfied': '不滿意',
  'Neutral': '一般',
  'Satisfied': '滿意',
  'Very Satisfied': '非常滿意',
  'Attachment': '附件',
  'Is there anything we can help you with?': '有什麼問題需要我們幫忙嗎？',
  'Your email': '您的信箱',
  'Hello, we have received your feedback and will respond to you as soon as possible. Please be patient, and thank you for your understanding.': '您好，我們已收到您的回饋，並將盡快回覆您。請耐心等待，感謝您的理解。',
  'Submission Failed': '提交失敗',
  'Please correctly fill in your email address.': '請正確填寫您的信箱地址。',
  'Invalid email address, please re-enter.': '郵箱地址無效，請重新輸入。',
  'Please provide detailed feedback content.': '請詳細填寫您要回饋的內容。',
  'Unbind Card': '解綁卡',
  'Are you sure you want to unlink this credit card?': '確定解綁該信用卡嗎？',
  'Unbind': '解綁',
  'Use email verification': '使用郵箱驗證',
  'Use phone verification': '使用手機號碼驗證',
  'Permanently delete your personal information and all data, this operation can’t be reconvered.': '永久刪除您的個人資訊和所有數據，此操作無法恢復。',
  'Please select one of the currently linked accounts to receive the verification code to proceed with your account deactivation.': '請選擇已綁定的帳號之一進行驗證',
  'Other verification methods': '其它驗證方式',
  'All devices that have permission to log in to this account will be displayed here. If you do not want a device to continue logging into the account, you can remove the device in time and <a href="#" class="change-pass">change the password</a>.': '此處會顯示有權限登入該帳號的所有裝置。 如果您不希望某件裝置繼續登入該帳號，可以及時移除該裝置並<a href="#" class="change-pass">修改密碼</a>。',
  'All devices that have permission to log in to this account will be displayed here. If you do not want a device to continue logging into the account, you can remove the device in time.': '此處會顯示有權限登入該帳號的所有裝置。 如果您不希望某件裝置繼續登入該帳號，可以及時移除該裝置。',
  '<span>{inviteNickName}</span> invites you to join <span>{companyName}</span> to share UPDF membership benefits.': '<span>{inviteNickName }</span> 邀請你加入 <span>{companyName }</span>，共享 UPDF 會員權益',
  'You’ve been invited': '你已受邀',
  'Free Trial': '免費試用',
  'Accept now to access exclusive UPDF membership benefits.': '立即接受以取得 UPDF 會員專屬福利。',
  'Accept Invitation': '接受邀請',
  'Welcome aboard! You’re all set.': '歡迎加入！您已準備就緒。',
  'Download now to share membership benefits.': '下載並登入以解鎖 UPDF 的所有功能。',
  'Start Using UPDF': '開始使用 UPDF',
  'Account Details': '帳戶詳情',
  'After unsubscribing, you will no longer receive our email notifications, news, offers, and tips.': '取消訂閱後，您將不再收到我們的新聞、優惠和提示電子郵件。',
  'You can manage the credit card for your subscription order here. Credit cards are stored by third-party payment institutions, and we at UPDF do not store any credit card information. If you need to unbind, please cancel your subscription in “Product & Plans” first.': '您可以在此管理訂閱訂單的信用卡。信用卡由第三方支付機構存儲，UPDF 不會儲存任何信用卡資訊。如果您需要取消連結您的卡，請先在「產品和計畫」中取消訂閱。',
  'Order information only included orders purchased through rhe website. Apple Pay and Google Google Pay orders will not be displayed here.': '訂單資訊僅列出透過 UPDF 官方網站進行的訂單。來自第三方平台（例如 Apple Store 或 Goolge Play Store 或其他優惠網站）的訂單將不會顯示在此。',
  'Work': '工作',
  'Age': '年齡',
  'Please enter the code sent to<br><span>{account}</span>.': '請輸入發送至<span>{account}</span> 的驗證碼',
  'The code is valid for 10 minutes.': '驗證碼10分鐘內有效',
  'SSO Log in': 'SSO登入',
  'Upgrade AI Assistant to unlock more AI features': '升級AI助手，解鎖更多AI功能',
  'Profile Picture': '頭像',
  'Account Deletion Confirmation': '刪除帳號確認',
  'Email/phone number': '信箱/手機號',
  'Account/email/phone number': '帳號/信箱/手機號',
  'Account/email': '帳號/信箱',
  'Get our desktop/mobile app': '下載 UPDF',
  'Plan Types': '訂閱類型',
  'Details': '詳情',
  'Redeemable {isProduct} Membership Duration:': '可兌換的 {isProduct} 會員時長：',
  'Redeemable Membership Duration:': '可兌換的會員時長：',
  'Tax Code': '稅號',
  'http_error_4031': '您已是會員，不需重複購買',
  'Send code_2': '發送驗證碼',
  'View Plans': '立即購買',
  'Add Credit Card': '新增信用卡',
  'Account Information': '帳號資訊',
  'There are no orders. Would you like to upgrade your plan? <br>Please visit the pricing page to make a purchase.': '暫無訂單。您想升級您的方案嗎？ <br>請造訪定價頁面進行購買。',
  'Human-machine verification failed, <span>click to retry</span>': '人機驗證失敗，<span>點選重試</span>',
  'Subscribed Successfully': '訂閱成功',
  'Unsubscribe': '取消訂閱',
  'Upgrade to UPDF Sign Plan to unlock more Sign features': '升級為 UPDF Sign 會員，可解鎖更多 Sign 功能',
  'Subscribe': '訂閱',
  'Please scan the QR code using WeChat': '請使用微信掃描二維碼',
  'Enter your redemption code': '輸入您的兌換碼',
  'Credit Card': '信用卡',
  'Renews on {time} at {price}/{type}': '於 {time} 續訂，價格為 {price}/{type}',
}